import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-zimbabwe-vaf-calculator.component.scss';
var CalculatorZimbabweVafCalculator = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorZimbabweVafCalculator, _super);
    function CalculatorZimbabweVafCalculator(element) {
        var _this = _super.call(this, element) || this;
        // json
        _this.jsonUSD = {
            currency: '$',
            invoiceAmount: {
                default: '1000',
                min: '1000',
                max: '99999999'
            },
            deposit: {
                default: '20',
                min: '15',
                max: '60'
            },
            term: {
                default: '12',
                min: '6',
                max: '60'
            },
            termination: {
                default: '10',
                min: '3',
                max: '10'
            },
            interest: {
                default: '10',
                min: '5',
                max: '15'
            }
        };
        _this.jsonZIM = {
            currency: 'Z$',
            invoiceAmount: {
                default: '10000',
                min: '10000',
                max: '999999999'
            },
            deposit: {
                default: '20',
                min: '20',
                max: '60'
            },
            term: {
                default: '24',
                min: '6',
                max: '60'
            },
            termination: {
                default: '5',
                min: '3',
                max: '10'
            },
            interest: {
                default: '45',
                min: '20',
                max: '99'
            }
        };
        return _this;
    }
    CalculatorZimbabweVafCalculator.prototype.init = function () {
        this.currencyForm = Array.from(this.element.querySelectorAll('.calculator-form__title--currency'));
        this.currencyCalculator = Array.from(this.element.querySelectorAll('.calculator-item__title--currency'));
        this.currencyTotal = Array.from(this.element.querySelectorAll('.js-total-currency'));
        this.selectCurrency = this.element.querySelector('select[name=currency]');
        this.inputInvoiceValue = this.element.querySelector('input[name=invoice_value]');
        this.inputDeposit = this.element.querySelector('input[name=deposit_rate]');
        this.inputTerm = this.element.querySelector('input[name=term]');
        this.inputTermination = this.element.querySelector('input[name=termination_value]');
        this.inputInterest = this.element.querySelector('input[name=interest_rate]');
        this.inputTermination.setAttribute('disabled', 'disabled');
        this.totalMonthly = this.element.querySelector('.js-monthly');
        // this.totalAssetValue = this.element.querySelector('.js-asset-value');
        this.totalDepositValue = this.element.querySelector('.js-deposit-rate');
        this.totalTerminationValue = this.element.querySelector('.js-termination-rate');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.containerSchedule = document.querySelector('.js-amort-schedule');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        if (this.element.getAttribute('data-terms-text')) {
            this.dataCtaButtonText = this.element.getAttribute('data-terms-text');
        }
        if (this.element.getAttribute('data-terms-link')) {
            this.dataCtaButtonText = this.element.getAttribute('data-terms-link');
        }
        if (this.element.getAttribute('data-disclaimer')) {
            this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        }
        this.calculate();
    };
    CalculatorZimbabweVafCalculator.prototype.bindEvents = function () {
        var _this = this;
        this.selectCurrency.addEventListener('change', function (evt) {
            var element = evt.target;
            if (element.value === 'ZWL') {
                _this.buildCalculator(_this.jsonZIM);
            }
            else {
                _this.buildCalculator(_this.jsonUSD);
            }
        });
        this.inputTerm.addEventListener('keyup', function (evt) {
            var element = evt.target;
            if (parseInt(element.value) <= 12) {
                _this.inputTermination.setAttribute('value', '10');
                _this.inputTermination.value = 10;
            }
            if (parseInt(element.value) > 12 && parseInt(element.value) <= 24) {
                _this.inputTermination.setAttribute('value', '5');
                _this.inputTermination.value = 5;
            }
            if (parseInt(element.value) > 24) {
                _this.inputTermination.setAttribute('value', '3');
                _this.inputTermination.value = 3;
            }
        });
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
    };
    CalculatorZimbabweVafCalculator.prototype.buildCalculator = function (json) {
        this.currencyForm.map(function (item) {
            item.innerHTML = json.currency;
        });
        this.currencyCalculator.map(function (item) {
            item.innerHTML = json.currency;
        });
        this.currencyTotal.map(function (item) {
            item.innerHTML = json.currency;
        });
        this.inputInvoiceValue.setAttribute('value', json.invoiceAmount.default);
        this.inputInvoiceValue.value = json.invoiceAmount.default;
        this.inputInvoiceValue.setAttribute('data-validation-greater-than', json.invoiceAmount.min);
        this.inputInvoiceValue.setAttribute('min', json.invoiceAmount.min);
        this.inputInvoiceValue.setAttribute('data-validation-less-than', json.invoiceAmount.max);
        this.inputInvoiceValue.setAttribute('max', json.invoiceAmount.max);
        this.inputDeposit.setAttribute('value', json.deposit.default);
        this.inputDeposit.value = json.deposit.default;
        this.inputDeposit.setAttribute('data-validation-greater-than', json.deposit.min);
        this.inputDeposit.setAttribute('min', json.deposit.min);
        this.inputDeposit.setAttribute('data-validation-less-than', json.deposit.max);
        this.inputDeposit.setAttribute('max', json.deposit.max);
        this.inputTerm.setAttribute('value', json.term.default);
        this.inputTerm.value = json.term.default;
        this.inputTerm.setAttribute('data-validation-greater-than', json.term.min);
        this.inputTerm.setAttribute('min', json.term.min);
        this.inputTerm.setAttribute('data-validation-less-than', json.term.max);
        this.inputTerm.setAttribute('max', json.term.max);
        this.inputTermination.setAttribute('value', json.termination.default);
        this.inputTermination.value = json.termination.default;
        this.inputTermination.setAttribute('data-validation-greater-than', json.termination.min);
        this.inputTermination.setAttribute('min', json.termination.min);
        this.inputTermination.setAttribute('data-validation-less-than', json.termination.max);
        this.inputTermination.setAttribute('max', json.termination.max);
        this.inputInterest.setAttribute('value', json.interest.default);
        this.inputInterest.value = json.interest.default;
        this.inputInterest.setAttribute('data-validation-greater-than', json.interest.min);
        this.inputInterest.setAttribute('min', json.interest.min);
        this.inputInterest.setAttribute('data-validation-less-than', json.interest.max);
        this.inputInterest.setAttribute('max', json.interest.max);
        this.calculate();
    };
    CalculatorZimbabweVafCalculator.prototype.calculate = function () {
        // amort array
        var amortArray = [];
        this.containerSchedule.innerHTML = '';
        // calculate deposit
        var depositRate = 0;
        depositRate = parseFloat(this.inputInvoiceValue.value) / 100 * parseFloat(this.inputDeposit.value);
        this.totalDepositValue.innerHTML = this.formatter(this.round(depositRate, 2));
        // calculate termination
        var terminationRate = 0;
        terminationRate = parseFloat(this.inputInvoiceValue.value) / 100 * parseFloat(this.inputTermination.value);
        this.totalTerminationValue.innerHTML = this.formatter(this.round(terminationRate, 2));
        // calculate future value
        var fv = 0;
        var interestRate = parseFloat(this.inputInterest.value);
        var invoiceValue = parseFloat(this.inputInvoiceValue.value);
        fv = this.FV(interestRate / 1200, 1, 0, (-invoiceValue) + depositRate, 1);
        // this.totalAssetValue.innerHTML = this.formatter(this.round(fv, 0));
        // calculate month installment
        var pmt = 0;
        var term = parseFloat(this.inputTerm.value);
        pmt = this.PMT(interestRate / 1200, term - 1, -fv, terminationRate, 1);
        this.totalMonthly.innerHTML = this.formatter(this.round(pmt, 2));
        // amort array first line
        var firstLine = {
            month: 0,
            loanAmount: parseFloat(this.inputInvoiceValue.value),
            installment: depositRate,
            interest: '-',
            principal: depositRate,
            balance: parseFloat(this.inputInvoiceValue.value) - depositRate
        };
        amortArray.push(firstLine);
        // calculate amort
        var loanStartAmount = parseFloat(this.inputInvoiceValue.value) - depositRate;
        var loanTerm = parseFloat(this.inputTerm.value);
        for (var index = 1; index < (loanTerm + 1); index++) {
            var calcMonthInterest = loanStartAmount * (interestRate / 100) / 12;
            var calcMonthPrincipal = pmt - calcMonthInterest;
            var lineItem = {
                month: index,
                loanAmount: loanStartAmount,
                installment: pmt,
                interest: calcMonthInterest,
                principal: calcMonthPrincipal,
                balance: loanStartAmount - calcMonthPrincipal
            };
            loanStartAmount = loanStartAmount - calcMonthPrincipal;
            amortArray.push(lineItem);
        }
        var totalInstallment = 0;
        var totalInterest = 0;
        var totalPrincipal = 0;
        var output = "";
        output += "<table class=\"table table--blue table-responsive table-striped static_header\"><thead><tr>\n\t\t\t\t<th>Month</th>\n\t\t\t\t<th>Loan Amount</th>\n\t\t\t\t<th>Installment</th>\n\t\t\t\t<th>Interest Portion</th>\n\t\t\t\t<th>Principal Portion</th>\n\t\t\t\t<th>Balance</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>";
        for (var index = 0; index < amortArray.length; index++) {
            var element = amortArray[index];
            if ((index + 1) === amortArray.length) {
                output += "\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td>" + element.month + "</td>\n\t\t\t\t\t\t<td>" + this.formatter(this.round(element.loanAmount, 0)) + "</td>\n\t\t\t\t\t\t<td>" + this.formatter(this.round(terminationRate, 0)) + "</td>\n\t\t\t\t\t\t<td>" + this.formatter(this.round(element.interest, 0)) + "</td>\n\t\t\t\t\t\t<td>" + this.formatter(this.round(element.loanAmount, 0)) + "</td>\n\t\t\t\t\t\t<td>-</td>\n\t\t\t\t\t</tr>\n\t\t\t\t";
                totalInstallment += terminationRate;
                totalInterest += element.interest;
                totalPrincipal += element.loanAmount;
            }
            else {
                totalInstallment += element.installment;
                totalPrincipal += element.principal;
                if (index > 0) {
                    totalInterest += element.interest;
                    output += "\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td>" + element.month + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.loanAmount, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.installment, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.interest, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.principal, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.balance, 0)) + "</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t";
                }
                else {
                    output += "\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td>" + element.month + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.loanAmount, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.installment, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + element.interest + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.principal, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.balance, 0)) + "</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t";
                }
            }
        }
        output += "</tbody>\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th colspan=\"2\">Total</th>\n\t\t\t\t\t<th>" + this.formatter(this.round(totalInstallment, 0)) + "</th>\n\t\t\t\t\t<th>" + this.formatter(this.round(totalInterest, 0)) + "</th>\n\t\t\t\t\t<th>" + this.formatter(this.round(totalPrincipal, 0)) + "</th>\n\t\t\t\t\t<th></th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t</table>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        this.containerSchedule.appendChild(docfragment);
    };
    CalculatorZimbabweVafCalculator.prototype.FV = function (rate, nper, pmt, pv, type) {
        var pow = Math.pow(1 + rate, nper), fv;
        pv = pv || 0;
        type = type || 0;
        if (rate) {
            fv = (pmt * (1 + rate * type) * (1 - pow) / rate) - pv * pow;
        }
        else {
            fv = -1 * (pv + pmt * nper);
        }
        return fv;
    };
    CalculatorZimbabweVafCalculator.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorZimbabweVafCalculator.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorZimbabweVafCalculator.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    return CalculatorZimbabweVafCalculator;
}(Base));
export { CalculatorZimbabweVafCalculator };



//////////////////
// WEBPACK FOOTER
// ./components-zimbabwe/calculator-zimbabwe-vaf-calculator/calculator-zimbabwe-vaf-calculator.component.ts
// module id = 589
// module chunks = 0